import { type PlacementId } from '@schibsted-nmp/advertising-shared';

import { debug as _debug } from './.debug.js';

const debug = _debug.withSublabel('Event', 'slotOnLoad');

/** Fired when a creative iframe fires its onload event. */
export function onSlotOnload(event: googletag.events.SlotOnloadEvent) {
  const placementId = event.slot.getSlotElementId() as PlacementId;

  debug.withPlacementLabel(placementId).message('').verbose();
}
